"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Component2 = _interopRequireDefault(require("../../Component"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _documentOffset = _interopRequireDefault(require("document-offset"));

var _main = _interopRequireDefault(require("../templates/main"));

var _syntheticEvent = _interopRequireDefault(require("../../../utils/syntheticEvent"));

var _react = _interopRequireDefault(require("react"));

var _stringifyDefault = function _stringifyDefault(value) {
  if (value && typeof value.toString === 'function') {
    return value.toString('f yyyy');
  } else {
    return value;
  }
};

var Main =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Main, _Component);

  function Main(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Main);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Main).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "template", _main["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleFocus", function (event) {
      _this.setState({
        active: true
      }).then(function () {
        _this._setPickerPosition();

        if (typeof _this.props.onFocus === 'function') {
          _this.props.onFocus(event);
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleBodyClick", function () {
      var _this$root$current;

      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (_this.state.active && !((_this$root$current = _this.root.current) === null || _this$root$current === void 0 ? void 0 : _this$root$current.contains(event.target))) {
        _this.setState({
          active: false
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setPickerPosition", function () {
      if (_this.picker.current) {
        var _this$root$current2;

        var minPickerOffset = _this.props.minPickerOffset,
            docH = window.document.body.offsetHeight,
            docW = window.document.body.offsetWidth,
            pickerHeight = _this.picker.current.offsetHeight,
            pickerReservedHeight = pickerHeight + minPickerOffset,
            offset = (0, _documentOffset["default"])(_this.root.current),
            availTop = offset.top,
            availBottom = docH - offset.top - ((_this$root$current2 = _this.root.current) === null || _this$root$current2 === void 0 ? void 0 : _this$root$current2.offsetHeight),
            pickerPosition = {};

        if (availBottom < pickerReservedHeight && availTop >= pickerReservedHeight) {
          pickerPosition.bottom = 'calc(100% + 2px)';
          pickerPosition.top = 'auto';
          pickerPosition.transformOrigin = 'left bottom';
        } else {
          pickerPosition.top = 'calc(100% + 2px)';
          pickerPosition.bottom = 'auto';
          pickerPosition.transformOrigin = 'left top';
        } // DP width + 18


        if (docW - offset.left - 290 <= 0) {
          pickerPosition.left = 'auto';
          pickerPosition.right = 0;
        }

        _this.setState({
          pickerPosition: pickerPosition
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleSubmit", function (value) {
      _this.value = value;
      return _this.setState({
        active: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleCancel", function () {
      return _this.setState({
        active: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleCalendarClick", function () {
      _this.input.focus();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleHover", function () {
      if (!_this.state.hover) {
        _this.setState({
          hover: true
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleRootBlur", function () {
      if (_this.state.hover) {
        _this.setState({
          hover: false
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleBlur", function (event) {
      var _this$root$current3;

      // блюр срабатывает так же при выборе элемента из списка, в таком случае нам не нужна обработка введенных в инпут данных
      if (event.relatedTarget && !((_this$root$current3 = _this.root.current) === null || _this$root$current3 === void 0 ? void 0 : _this$root$current3.contains(event.relatedTarget))) {
        _this.setState({
          active: false
        });

        if (typeof _this.props.onBlur === 'function') {
          _this.props.onBlur(event);
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_inputRef", function (el) {
      _this.input = el;
      var elementRef = _this.props.elementRef;

      if (typeof elementRef === 'function') {
        elementRef(el);
      } else if ((0, _typeof2["default"])(elementRef) === 'object') {
        elementRef.current = el;
      }
    });
    _this.state = {
      active: false,
      hover: false,
      pickerPosition: null
    };
    _this.root = _react["default"].createRef();
    _this.picker = _react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(Main, [{
    key: "value",
    set: function set(value) {
      var target = {
        name: this.input.name,
        type: this.input.type,
        focus: this.input.focus,
        value: value
      };

      if (typeof this.props.onChange === 'function') {
        this.props.onChange((0, _syntheticEvent["default"])(target));
      }
    }
  }]);
  return Main;
}(_Component2["default"]);

(0, _defineProperty2["default"])(Main, "propTypes", {
  minYear: _propTypes["default"].number,
  maxYear: _propTypes["default"].number,
  yearChange: _propTypes["default"].bool,
  deniedDates: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].bool, _propTypes["default"].array]),
  allowedDates: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].bool, _propTypes["default"].array]),
  allowedMonths: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].bool, _propTypes["default"].array]),
  isPeriod: _propTypes["default"].bool,
  onSubmit: _propTypes["default"].func,
  onCancel: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  elementRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  className: _propTypes["default"].string,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default url("${calendar}")
     */
    appearance: _propTypes["default"].string,

    /**
     * @default url("${calendarHover}")
     */
    appearanceHover: _propTypes["default"].string,

    /**
     * @default url("${calendarDisabled}")
     */
    appearanceDisabled: _propTypes["default"].string,

    /**
     * @default inline-block
     */
    display: _propTypes["default"].string,

    /**
     * @default palette.zOverlay
     */
    zIndex: _propTypes["default"].number,

    /**
     * @default auto
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  }),
  disabled: _propTypes["default"].bool,
  minPickerOffset: _propTypes["default"].number,
  onChange: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  stringify: _propTypes["default"].func,
  readOnly: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(Main, "defaultProps", {
  readOnly: true,
  stringify: _stringifyDefault,
  minPickerOffset: 18
});
(0, _defineProperty2["default"])(Main, "displayName", 'MonthInput');
var _default = Main;
exports["default"] = _default;